<template lang="pug">
.dashboard-section
  .section-header
    .section-title
      h2 Mis pendientes
      p Actividades personales que todavía tienes por completar.
  .cards-grid
    StatCard(
      v-for="item in lista"
      :key="item.id"
      :titulo="item.titulo"
      :cantidad="item.cantidad"
      tipo="primary"
      @click="redirigir(item.ruta)"
    )
</template>
<script>
import { apiGet, notify }  from '../../../util/general'
import StatCard from './c_statCard'
export default {
  name: 'MisPendientes',
  components: {
    StatCard
  },
  data () {
    return {
      lista    : [
        {
          id: 1,
          titulo: 'Documentos sin firmar',
          cantidad: 5,
          ruta: '/mis-documentos-firmar'
        },
        {
          id: 2,
          titulo: 'Contratos sin firmar',
          cantidad: 3,
          ruta: '/mis-contratos'
        },
        {
          id: 3,
          titulo: 'Boletas sin revisar',
          cantidad: 7,
          ruta: '/boletas'
        }
      ],
      isLoading: true
    };
  },
  created () {
    this.fetch();
  },
  methods: {
    fetch () {
      var vm = this
      vm.isLoading = true
      apiGet(vm, '/documentos-firmar/sin-cargar', {}, function (data) {
        vm.lista[0].cantidad = data.lista.length
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        apiGet(vm, '/contratos/obtener/mis-contratos', {}, function (data) {
          const cantidad = data.lista.filter(a => !a.firmado).length
          vm.lista[1].cantidad = cantidad
        }, function (error) {
          notify(vm, 'error', 'Error', error.message)
        }, function () {
          var obj = {
            periodo: new Date().getFullYear()
          }
          apiGet(vm, '/boleta/empleado', obj, function (data) {
            const cantidad1 = data.lista.filter(a => !a.fechaVisto).length
            vm.lista[2].cantidad = cantidad1
          }, function (error) {
            console.error('error', error)
          }, function () {
            vm.isLoading = false
          })
        })
      })
    },
    redirigir (to) {
      this.$router.push(to)
    }
  }
}
</script>
<style scoped>
.dashboard-section {
  padding: 20px;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  margin-bottom: 20px;
}
.section-header {
  margin-bottom: 17px;
}
.section-title h2 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #292d32;
}
.section-title p {
  margin: 4px 0 0;
  font-size: 12px;
  color: #8b9097;
}
.cards-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
}
@media(max-width: 850px) {
  .cards-grid {
    grid-template-columns: 1fr;
  }
}
</style>



// WEBPACK FOOTER //
// c_mis_pendientes.vue?ffc8dcb0